import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import EventHeader from './EventHeader';
import {Tooltip} from '@/components/tooltips';
import Icon from '@/components/icons/Icon';
import i18n from 'i18n';

interface EventQuickViewHeaderProps {
    eventType?: string;
    eventId: string;
    channelName?: string;
    dateTime?: string;
    eventAgent?: string;
    eventCustomer?: string;
    canOpenDetailView: boolean;
    detailUrl?: string;
    onClose: () => void;
    /** Optional human-readable language label, e.g. "Language: en" */
    languageLabel?: string;
}

const EventQuickViewHeader: React.FC<EventQuickViewHeaderProps> = React.memo(({
    eventType,
    eventId,
    channelName,
    dateTime,
    eventAgent,
    eventCustomer,
    canOpenDetailView,
    detailUrl,
    onClose,
    languageLabel,
}) => {
    return (
        <div className="my-2">
            <Container>
                <Row>
                    <Col className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column flex-grow-1">
                            <EventHeader
                                eventType={eventType || ''}
                                eventId={eventId}
                                channelName={channelName}
                                dateTime={dateTime}
                                eventAgent={eventAgent || ''}
                                eventCustomer={eventCustomer || ''}
                            />
                            {languageLabel && (
                                <div className="mt-1 text-muted small">
                                    {languageLabel}
                                </div>
                            )}
                        </div>
                        <div className="d-flex align-items-center">
                            {canOpenDetailView && detailUrl ? (
                                <Tooltip
                                    content={i18n.t('tt_event_view.text')}
                                    placement="top"
                                >
                                    <a
                                        className='btn btn-outline-info btn-sm icon-button mx-2'
                                        href={detailUrl}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        <Icon name='mdi-eye' />
                                    </a>
                                </Tooltip>
                            ) : null}
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
});

export default EventQuickViewHeader;


